if (typeof window !== 'undefined') {
  const debounce = (callback, delay) => {
    let timeoutId
    return function (...args) {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => callback.apply(this, args), delay)
    }
  }

  const OriginalResizeObserver = window.ResizeObserver

  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      const debouncedCallback = debounce(callback, 16)
      super(debouncedCallback)
    }
  }

  window.addEventListener('error', (event) => {
    if (
      event.message &&
      (event.message.includes('ResizeObserver loop') ||
        event.message.includes('ResizeObserver loop completed with undelivered notifications'))
    ) {
      event.stopImmediatePropagation()
      event.preventDefault()
      return false
    }
  })

  const originalError = console.error
  console.error = function (...args) {
    if (args.length > 0 && typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
      return
    }
    originalError.apply(console, args)
  }
}
